// import React from "react";
import {
  fetchInboxMessages,
  fetchNotification,
  receivedMessage,
  // fetchMessagesCounts,
  getConversationCountInit,
  // receivedMessageInit,
  receivedMessageFailure,
  receivedMessageSuccess,
  fetchChatHistory,
} from "../redux/actions";
import store from "../redux/store";
const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
const websocketURL = process.env.REACT_APP_WEB_SOCKET_URL
// let socket = new WebSocket(
//   //WebSocket Url
//   // `ws://192.168.18.48:3001?UserId=${UserId}`
//   `wss://t5v4jatt1m.execute-api.us-east-2.amazonaws.com/development?UserId=${'637cb46e06c29f17babcc749'}`,
// );
export class WS {
  // initialize socket connection and sending a join request
  static init(UserId, msg, users) {
    this.ws = new WebSocket(
      //WebSocket Url
      // `ws://192.168.18.48:3001?UserId=${UserId}`
      // kt6m7lx9vc.execute-api.us-east-2.amazonaws.com/staging
      // `wss://3el03f9ofa.execute-api.us-east-2.amazonaws.com/production?UserId=${UserId}`
      // `wss://rde98i1kyk.execute-api.us-east-2.amazonaws.com/staging?UserId=${UserId}`
      `${websocketURL}?UserId=${UserId}`
      // `ws://192.168.18.101:4001?UserId=${UserId}`,
    );
    this.ws.onopen = () => {
      this.ws.send(
        JSON.stringify({
          action: "join",
          user: UserId,
        })
      );
      // this.ws.send(
      //   JSON.stringify({
      //     action: 'ping',
      //   }),
      // );
    };

    this.ws.onmessage = ({ data }) => {
      try {
        const messageData = JSON.parse(data);
        console.log('messageData', messageData)
        if(messageData?.data?.Status=='Accepted Interview'&& messageData?.data?.ConversationId) {
          store.dispatch(fetchChatHistory(messageData?.data?.ConversationId));
        }
      } catch (error) {
        console.warn(error);
      }
      store.dispatch(
        receivedMessage(
          { ...JSON.parse(data) },
          { SecondarySourceTypeName: "Bid" }
        )
      );
      store.dispatch(fetchNotification({
        fromSocket: true
      }));
      store.dispatch(getConversationCountInit());
      store.dispatch(receivedMessageSuccess());
      store.dispatch(fetchNotification());
      // store.dispatch(fetchMessagesCounts("all_bids"));
      store.dispatch(
        fetchInboxMessages("null", "all_conversations", null, 1, 1)
      );
      // this.onMessage({data})
      // maintain connection replying a ping with a ping
      if (JSON.parse(data).action === "ping" && this.ws.readyState === 1) {
        try {
          setTimeout(() => {
            try {
              this.ws.send(JSON.stringify({ action: "ping" }));
            } catch (e) {
              console.warn(e);
            }
          }, 5000);
        } catch (e) {
          console.warn(e);
          store.dispatch(receivedMessageFailure());
        }
      }
    };

    this.ws.onerror = (event) => {
      console.warn(event);
    };
    this.ws.onclose = (event) => {
      if (UserId) {
        setTimeout(() => {
          this.init(UserId);
          this.onMessage();
        }, 1000);
      }
    };
  }
  //close sockets
  static onClose(handler) {
    this.ws.close();
  }
  //Receive Msg
  static onMessage(handler) {
    this.ws.addEventListener("message", handler);
  }
  static sendMessage(message) {
    // socket.send(message);
    this.ws.send(message);
  }
}
